

import {URL} from 'Core/Common/Url';
import {Request, IRequestOptions} from 'Core/Common/Request';
import {P} from 'Core/Common/Promise';
import {GenericDeserialize} from 'libs/cerialize';
import {BlobFieldModel} from 'Core/Screens/DesignScreen/ControlEditor/Models/BlobFieldModel';

export interface IGetBlobFieldsRequestModel {
	ControlTypeName: string;
	ContextEntityId: number;
	IsControlInMainSubForm: boolean;
};

export class BlobFieldsStore {
	static Get(params: IGetBlobFieldsRequestModel): P.Promise<Array<BlobFieldModel>> {
		var deferredResult = P.defer<Array<BlobFieldModel>>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: "/api/FormDesignerApi/GetBlobFields",
				dataType: "json",
				type: "POST"
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {
				if ( data.IsSuccessfull ) {
					deferredResult.resolve(this.Deserialize(data));
				}
			});

		return deferredResult.promise();
	}

	static Deserialize(jsonObject: any): any {
		var model = GenericDeserialize<BlobFieldModel>(jsonObject.Data, BlobFieldModel);
		return model;
	}
}